import tw from "./tw";
import ja from "./ja";
import ko from "./ko";
export default {
  "zh-TW": tw,
  ja,
  ko,
};
